export function addOrderData(orderData) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_ORDER_DATA',
                payload: orderData
            });
            resolve(true)
        });
    }
};

export function resetOrderData() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'RESET_ORDER_DATA'
            });
            resolve(true)
        });
    }
};